import React from 'react';
import List, { defaultFilters } from '../../cruds/List';
import View from '../../cruds/View';
import Edit from '../../cruds/Edit';
import { notNull, stringNotBlank } from '../../cruds/validators';
import Table, { Column } from '../../components/container/Table';
import { EditButton, ViewButton, DeleteButton } from '../../components/output/CrudButton';
import OutputValue, { LocalizedOutputValue } from '../../components/output/OutputValue';
import OutputText, { LocalizedOutputText } from '../../components/output/OutputText';
import InputText from '../../components/input/InputText';
import RemoteInputSelect from '../../components/input/RemoteInputSelect';
import RadioButtonGroup, { RadioButton } from '../../components/input/RadioButtonGroup';
import DownloadButton from '../../components/output/DownloadButton';
import MainContainer from '../../components/MainContainer';
import { Switch, Route } from 'react-router-dom';
import WithRole, { withRoles } from '../../components/container/WithRole';

const ENTITY_NAME = 'departments';
const TITLE = 'departments.title';

const CrudEdit = props => {
  const validators = [
    stringNotBlank('name', 'departments.err.name'),
    notNull('companyId', 'departments.err.companyId'),
    notNull('state', 'departments.err.state'),
  ];
  return (
    <Edit {...props}
          title={TITLE}
          entityName={ENTITY_NAME}
          entityRoute={ENTITY_NAME}
          entityId={props.match.params.number}
          validators={validators}
          initialValue={{ state: 'ACTIVE' }}
    >
      <InputText name="name" label="departments.name" required />
      <InputText name="area" label="departments.area" />
      <RemoteInputSelect from="companies"
    	  	  order="NAME"
              optionValueName="id"
              optionLabelName="name"
              name="companyId"
              label="departments.companyId"
              required
      />
      <InputText name="manager" label="departments.manager" />
      <RadioButtonGroup name="state" label="departments.state.name" required>
        <RadioButton value="ACTIVE" label="departments.state.ACTIVE" />
        <RadioButton value="INACTIVE" label="departments.state.INACTIVE" />
      </RadioButtonGroup>
      <InputText name="building" label="departments.building" />
      <InputText name="labManager" label="departments.labManager" />
      <InputText name="site" label="departments.site" />
      <InputText name="dvrIt" label="departments.dvrIt" />
      <InputText name="notes" label="departments.notes" />
    </Edit>
  );
};

const CrudView = props => (
  <View title={TITLE}
      entityName={ENTITY_NAME}
      entityRoute={ENTITY_NAME}
      entityId={props.match.params.number}
  >
    <OutputText name="name" label="departments.name" />
    <OutputText name="area" label="departments.area" />
    <OutputText name="companyName" label="departments.companyName" />
    <OutputText name="manager" label="departments.manager" />
    <LocalizedOutputText name="state" prefix="departments.state" label="departments.state.name" />
    <OutputText name="building" label="departments.building" />
    <OutputText name="labManager" label="departments.labManager" />
    <OutputText name="site" label="departments.site" />
    <OutputText name="dvrIt" label="departments.dvrIt" />
    <OutputText name="notes" label="departments.notes" />
  </View>
);

const exportButtons = (filters, context, toggleModal) => {
  return (
    <span>
      <DownloadButton from={ENTITY_NAME}
          filters={filters}
          type="application/vnd.ms-excel"
          extension="xls"
          tooltip="general.export"
          handleError={toggleModal}
      />
      <DownloadButton
          from={ENTITY_NAME}
          filters={filters}
          type="application/pdf"
          extension="pdf"
          tooltip="general.print"
          iconType="printer"
          handleError={toggleModal}
      />
    </span>
  );
};

const CrudList = props => {
  const table = <Table>
                  <Column label="departments.name" orderingName="NAME"><OutputValue name="name" /></Column>
                  <Column label="departments.area" orderingName="AREA"><OutputValue name="area" /></Column>
                  <Column label="departments.companyName" orderingName="COMPANY"><OutputValue name="companyName" /></Column>
                  <Column label="departments.manager" orderingName="MANAGER"><OutputValue name="manager" /></Column>
                  <Column label="departments.state.name" orderingName="STATE">
                    <LocalizedOutputValue name="state" prefix="departments.state" />
                  </Column>
                  <Column label="departments.building" orderingName="BUILDING"><OutputValue name="building" /></Column>
                  <Column label="departments.labManager" orderingName="LAB_MANAGER"><OutputValue name="labManager" /></Column>
                  <Column label="departments.site" orderingName="SITE"><OutputValue name="site" /></Column>
                  <Column label="departments.dvrIt" orderingName="DVRIT"><OutputValue name="dvrIt" /></Column>
                  <Column label="departments.notes"><OutputValue name="notes" /></Column>
                  <Column>
                    <WithRole roles={['A', 'B']}>
                      <EditButton entityRoute={props.match.url} />
                    </WithRole>
                    <ViewButton entityRoute={props.match.url} />
                    <WithRole roles={['A', 'B']}>
                      <DeleteButton />
                    </WithRole>
                  </Column>
                </Table>;

  return (
    <List title={TITLE}
          entityName={ENTITY_NAME}
          entityRoute={ENTITY_NAME}
          component={table}
          filters={defaultFilters()}
          additionalButtons={exportButtons}
          defaultOrdering="NAME"
          hideAddButton = {!withRoles(['A', 'B'])}
    />
  );
};

const Departments = props => {
  const basePath = props.match.url;
  return (
    <MainContainer>
      <Switch>
        <Route exact path={basePath} component={CrudList} />
        <Route exact path={basePath + '/view/:number'} component={CrudView} />
        <Route exact path={basePath + '/edit/:number'} render={props => <CrudEdit {...props} />} />
        <Route exact path={basePath + '/add'} render={props => <CrudEdit {...props} />} />
      </Switch>
    </MainContainer>
  );
};

export default Departments;



// WEBPACK FOOTER //
// ./src/main/pages/registry/Departments.js